function ABPASSIntrigation() {
  return (
    <div>
      <div style={{ width: "100%", height: "100%" }}>
        <iframe
          src="/ABPASS.html" // your HTML file in public folder
          title="ABPASS Intersection"
          width="100%"
          height="900px"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
}

export default ABPASSIntrigation;
